import React, { useState, useEffect } from 'react';
import { Modal, Button, ButtonProps } from 'antd';
import { useTrans } from 'base/utils/i18n';
import { Loading } from '@base/lib/ThemeLoadingV2'
import { COOKIE_AGE_GATE } from 'mod/age-gate/constant'
import { setCookie, getCookie } from 'ava-util/dist/cookie';
import { useAgeGate } from 'mod/age-gate/useAgeGate';
import { useStoreState } from 'base/store';
import { useRouter } from 'next/router';
import { COOKIE_COUNTRY } from 'base/config/constant';
import { checkAgeGate } from 'mod/age-gate/utils';
import cn from 'classnames';

type SubscribeModalProps = {
    modalClassName?: string;
    className?: string;
    serverAgeLimit?: boolean; // 直接打开
    logo?: React.ReactElement;
    btnYesProps?: ButtonProps;
    btnNotProps?: ButtonProps;
};

const AgeGateModal: React.FC<SubscribeModalProps> = (props) => {
    const [visible, setVisible] = useState<boolean>(false)
    const {
        className,
        modalClassName,
        serverAgeLimit = false,
        logo,
        btnYesProps,
        btnNotProps
    } = props;
    const { t } = useTrans();
    const { age, loading } = useAgeGate();
    const { country } = useStoreState('rootStore');
    const router = useRouter();

    const { query } = router;
    let ageName = `${COOKIE_AGE_GATE}_${country}`
    const cookies = {
        [COOKIE_COUNTRY]: getCookie(COOKIE_COUNTRY),
        [ageName]: getCookie(ageName)
    }

    const showAgeGate = checkAgeGate(serverAgeLimit, query, cookies)

    useEffect(() => {
        if (showAgeGate) {
            setVisible(true)
        }
    }, [showAgeGate])

    return !showAgeGate ? null : (
        <>
            <Modal
                maskStyle={{
                    background: 'rgba(0,0,0,0.75)'
                }}
                className={cn(modalClassName)}
                closable={false}
                width={528}
                open={visible}
                centered
                footer={false}
                zIndex={2000}
            >
                <div className={className}>
                    <div className={'g-grid-1 flex flex-center'}>
                        <div className="g-logo">
                            {logo}
                        </div>
                    </div>
                    <div className={'g-grid-2 flex flex-center'}>
                        {loading || typeof age !== 'number'
                            ? <Loading/>
                            : (
                                <div className={'g-main'}>
                                    <p className={'g-desc'}>{t('web_age_gate_intro', { age })}</p>
                                    <p className={'g-desc'}>{t('web_age_gate_confirm_tip')}:</p>
                                    <Button
                                        onClick={() => {
                                            setCookie(`${COOKIE_AGE_GATE}_${country}`, 1, 365);
                                            setVisible(false)
                                            // router.replace 页面使用了 getServerSideProps 会报错
                                            // router.replace(router.query.redirect ? decodeURIComponent(router.query.redirect as string) : RouteEnum.SHOP);
                                        }}
                                        block
                                        className={'g-btn-yes'}
                                        {...btnYesProps}
                                    >
                                        <div>{t('web_age_gate_full_age', { age })}</div>
                                        <div>{t('web_age_gate_full_age_next')}</div>
                                    </Button>
                                    <Button
                                        // href={RouteEnum.HOME}
                                        block
                                        onClick={() => {
                                            window.history.back();
                                        }}
                                        className={'g-btn-not'}
                                        {...btnNotProps}
                                    >
                                        <div>{t('web_age_gate_under_age', { age })}</div>
                                        <div>{t('web_age_gate_under_age_next')}</div>
                                    </Button>
                                </div>
                            )}
                    </div>
                </div>
            </Modal>
        </>
    )
};

export default AgeGateModal;